import { MotivoRechazo, UsuarioSistemaProfile } from '../../administration';
import { Cliente } from '../../cliente.interface';
import { IContratoSimple } from '../../global';
import { ITrazabilidad } from '../../global/trazabilidad.interface';
import { Flota, Naps, Sector, Zone } from '../../mantenimiento-operaciones';
import { IDataPreventa } from '../../preventa';
import { IPromocion } from '../../promociones';
import {  IProspectOmitData } from '../../prospecto';
import {
  City,
  Country,
  IPaymentMethod,
  Plan,
  Province,
} from '../../system-settings';
import { ObservacionesAgendamiento } from '../agendamiento';

export interface PreagendamientosPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: IPreagendamiento[];

}

export interface IPreagendamiento {
  id_preagendamiento?: string;

  fecha_instalacion: string;
  hora_instalacion: string;
  coordenadas: string;
  distancia: string;

  url_foto_comprobante: string;
  numero_comprobante: string;

  usos?: UsosPreagendaType;
  encuesta: EncuestaPreagendaType;

  codigo: string;
  estado: boolean;
  numero_referencia: string;
  estado_preagendamiento: string; // choice
  estado_pago: string; // choice

  fecha_creacion: string;
  fecha_modificacion: string;
  descripcion_pago: string;
  detalle_instalacion: string;
  es_pyme?: boolean;
  // revisado x pyl
  revisado_pyl: boolean;
  fecha_revision_pyl: string; // timestamp

  id_instalacion_externa: string | null
  
  user_create: string | null
  ///* fk
  preventa: string;

  nap: string;
  flota: string;
  cliente: string;
  contrato: string;
  prospecto: string;
  vendedor: string; // username
  motivo_rechazo: string;

  prospecto_data: IProspectOmitData;
  //contrato_data: Contrato;
  contrato_data: IContratoSimple;
  preventa_data: IDataPreventa;
  flota_data: Flota;
  nap_data: Naps;
  vendedor_data: UsuarioSistemaProfile;
  motivo_rechazo_data?: MotivoRechazo;
  forma_pago_data: IPaymentMethod;
  /// helpers serialize
  pais_data?: Country;
  provincia_data?: Province;
  ciudad_data?: City;
  zona_data?: Zone;
  sector_data?: Sector;
  referido_flota_data?: Flota;
  referido_cliente_data?: Cliente;
  plan_data?: Plan;
  promociones_data?: any[];
  trazo_venta_data?: ITrazabilidad[];

  user_gestionando?: string | null;
  observaciones?: {
    observacion_llamada?: string, observacion_rechazo?: string,
    observacion_cancelacion?: string;
    observacion_tecnico_adicional?: string;
  };
  estado_llamada?: string;
  ciudad_nombre?: string;
  supervisor_data?: {
    razon_social: string;
    user: string;
  };
  estado_aceptacion?: boolean;
  fecha_aceptacion?: string;
  nap_data_nombre?: string;
  zona_data_nombre?: string;

  ///* pymes
  solicitar_tecnico?: boolean
  fecha_tecnico_adicional?: string
  hora_tecnico_adicional?: string
  nombre_pyme_enlace?: string
  representante_legal_tipo_identificacion?: string
  representante_legal_identificacion?: string
  representante_legal_razon_social?: string
  representante_celular1?: string
  representante_celular2?: string
  flota_adicional?: string | null
  //observacion_tecnico_adicional?: string
}

export type EncuestaPreagendaType = {
  numero_pisos: string;
  tipo_vivienda: string;
  como_se_entero: string;
  numero_dispositivos: string;
  herramienta_utilizada: string;
};
export type UsoPreagendaType = {
  juegos: boolean;
  domotica: boolean;
  streaming: boolean;
  redes_sociales: boolean;
  entretenimiento: boolean;
  trabajo_estudio: boolean;
};

export type PromocionPreagendaType = Pick<
  IPromocion,
  | 'id_promocion'
  | 'nombre'
  | 'codigo'
  | 'numero_referencia'
  | 'valor_descuento'
  | 'tipo_descuento'
  | 'estado'
>;

// module = PREAGENDAMIENTO
export enum MotivoRechazoPreagendaEnum {
  DOCUMENTOS_INVALIDOS = 'DOCUMENTOS_INVALIDOS',
  DATOS_INCORRECTOS = 'DATOS_INCORRECTOS',
}

export interface PreagendamientoActualizarDatos {
  tipo_identificacion: string;
  identificacion: string;
  razon_social: string;
  pais?: string;
  provincia: string;
  ciudad: string;
  zona: string;
  sector: string;
  direccion: string;
  celular: string;
  celular_2: string;
  email: string;
  persona_referencia: string;
  persona_referencia_celular: string;
  persona_referencia_celular_2: string;
  forma_pago: string;
  valor_instalacion: string;
  numero_tarjeta: string;
  entidad_financiera: string;
  tipo_cuenta_bancaria: string;
  numero_cuenta: string;
}

export type UsosPreagendaType = {
  juegos?: boolean;
  domotica?: boolean;
  streaming?: boolean;
  redes_sociales?: boolean;
  entretenimiento?: boolean;
  trabajo_estudio?: boolean;
};

export enum CacheKeyCalendarioENUM {
  KEY_CACHE_PREAGENDAMIENTO = 'preagendamiento_fecha_limite_preventa_',
  KEY_CACHE_PREAGENDAMIENTO_PYL = 'preagendamiento_fecha_limite_pyl_',
  //KEY_CACHE_AGENDAMIENTO_PYL = 'agendamiento_fecha_limite_pyl_',
  KEY_CACHE_COORP_AGENDAMIENTO_NOC = 'agendamiento_coorp_fecha_limite_noc_',

  TIEMPO_LIMITE = '00:10',
  TIEMPO_LIMITE_PYL = '00:01',

  MENSAJE_BLOQUEO = 'BLOQUEO TEMPORAL ASESOR',
  MENSAJE_BLOQUEO_PYL = 'BLOQUEADO POR PYL'
}

export interface FormMotivoRechazoPreagendamiento {
  id_preagendamiento: string;
  motivo_rechazo: string;
  razon_social?: string;
  identificacion?: string;
  observaciones?: ObservacionesAgendamiento;
  observacion_cancelacion?: string;
}


///* instalacion

export interface IEstadoInstalacion {
  id_inst: number
  nombre_cliente: string
  estado_venta: string
  estado_instalacion: string
}
